/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { ValidatorFn, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ModalController,AlertController, NavParams  } from '@ionic/angular';

@Component({
  selector: 'app-generic-input',
  templateUrl: './generic-input.page.html',
  styleUrls: ['./generic-input.page.scss'],
})
export class GenericInputPage implements OnInit {
  protected pageParameters : any;

  protected saveChangesButton : boolean = false;

  protected nextButtonHidden : boolean = true;

  protected newOption : any;

  protected otherOptionInput : string = "";   //user input |-> TODO: treat cases (number, specials, etc)

  // protected charMax : number;

  protected userData : any; //var for logged 'user' data

  constructor(
    public alertCtrl: AlertController,
    public navParams: NavParams,
    private translate: TranslateService,
    private modalCtrl: ModalController,

  ) { 

    this.userData = this.navParams.get('theSoul'); //getting 'user' data
    this.pageParameters = this.navParams.get('pageParameters');

    if(this.userData[this.pageParameters.fieldName] != undefined && this.userData[this.pageParameters.fieldName] != null && this.userData[this.pageParameters.fieldName] != ""){
      this.otherOptionInput = this.userData[this.pageParameters.fieldName];
    } 
  }
  ngOnInit(): void {
  }

  getCharsLeft(){    
    return this.pageParameters.maxLength - (this.otherOptionInput + "").length;

  }

  getCharStatus(){
    if(this.getCharsLeft() >= 10){
      return " full";
      
    } else if (this.getCharsLeft() < 10 && this.getCharsLeft() > 0){

      if(this.getCharsLeft() == this.pageParameters.maxLength){
        return " full";
      
      } else {
        return " filling";

      }

    } else if (this.getCharsLeft() == 0){
      return " empty";
    
    } else {
      return " negative"
    }
  }

  //closes modal without saving
  exitButton(){
    this.modalCtrl.dismiss('exitModal');
  }

  //switches 'exitButton' to 'saveButton'
  showSaveButton(){
    this.saveChangesButton = true;
  }

  //saves changes made by user
  saveButton(){
    if(this.saveOption()){
      this.modalCtrl.dismiss('exitModal');
    }
  }


  //sets what's been written in 'otherOptionInput' as 'genericOption'
  inputOtherOptionLostFocus(){
    this.showSaveButton();

    this.setOption(this.otherOptionInput);
    this.hideNextButton(false);
  }

  //sets 'nextButton's visibility
  hideNextButton(choice : boolean){
    this.nextButtonHidden = choice;
  }

  //"goes back" 1 modal and saves info
  backButton(){
    if(!this.saveOption() && this.pageParameters.firstSetup){
      return;// No need to prompt here as the form will already prompt if a required is not filled
    } else {
      this.modalCtrl.dismiss('backModal');
    }
  }

  //saves info and goes to next modal
  nextButton(){    
    switch(this.saveOption()){
      case true:
        this.modalCtrl.dismiss('nextModal');
        break;

      case false:
        break;
        
      default:
        break;  
    }

    /*if(!this.saveOption() && this.pageParameters.firstSetup){
      return;// No need to prompt here as the form will already prompt if a required is not filled
    } else if(this.saveOption()){
      this.viewCtrl.dismiss('nextModal');
    } else {
      return;
    }*/
 
  }

  saveOption() : boolean|any{
    console.log(this.pageParameters.firstName);
    if(!this.pageParameters.validator){
      this.userData[this.pageParameters.fieldName] = this.otherOptionInput;

      //alert("primeiro if");
        
      return true;
    } else {
      //alert("primeiro else");

      const validator : ValidatorFn = this.pageParameters.validator;
    
      const control = new FormControl(this.otherOptionInput, validator);

      //alert(JSON.stringify(control));
      
      if(control.status == 'VALID'){
        this.userData[this.pageParameters.fieldName] = this.otherOptionInput;
        //console.log("setado: ", this.otherOptionInput);

        //alert("segundo if");
        
        return true;
      } else {
        this.showModalAlert(this.translate.instant('invalidInput'));

        //alert("segundo else");
        return;
      }
    }
  }

  async showModalAlert(message: any) {
    const alert = this.alertCtrl.create({
      //title: this.translate.instant('statisticalOnly'),
      subHeader: message,
      buttons: [
        // {
        //   text: this.translate.instant('cancel'),
        //   handler: () => {
        //     console.log('cancel clicked');
        //     return;

        //   }
        // },
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    (await alert).present();
  }

  //sets 'genericOption'
  setOption(newOption : string){
    this.newOption = newOption;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GenderPage');
  }

}
